module.exports = __webpack_public_path__ + "static/media/medal.caad0414.png";